import React, { useState, useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import { Content } from 'antd/lib/layout/layout';
import { useNavigate } from 'react-router-dom';
import '../Components/style/layout.css';
import { FaFacebook, FaFileInvoiceDollar, FaHome, FaInstagram, FaLinkedin, FaUser } from 'react-icons/fa';
import { FiFileText, FiHome, FiUser, FiUsers } from 'react-icons/fi';
import { firebase } from '../base';
import { IconIndicator, IndicatorCustomized } from '../Components/spining';
import { MdFileOpen, MdFilePresent, MdOutlineStore } from 'react-icons/md';

const AdminLayout = () => {
  const [splash, setSplash] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    setTimeout(() => {
      if (window.location.pathname.includes('/admin/document')) {
        return;
      }
      if (firebase.auth().currentUser) {
        setSplash(false);
      } else {
        navigate('/signin');
      }
    }, 500);
  }, []);


  const goLogin = () => {
    navigate('/signin');
  }

  const goSignup = () => {
    navigate('/signup');
  }

  const goCreate = () => {
    navigate('/admin/invoices/create');
  }

  const logout = () => {
    firebase.auth().signOut().then(() => {
      navigate('/signin');
    }).catch((error) => {
      console.error(error);
    });
  }

  return (
    <>
      {window.location.pathname.includes('/admin/document') ? (
        <Outlet />
      ) : (
        <>
          {splash ? (<>
            <div className='w-full h-full flex items-center justify-center' style={{ height: '100vh' }}>
              <IconIndicator />
            </div>
          </>) : (
            <div className="main-page">
              <header className="header">
                <div className='header-content-admin'>
                  <div className='logo-container' onClick={() => navigate('/')}>
                    <img src={require('../assets/icons/nilia.webp')} className='logo' alt="Instituto Nilia" />
                  </div>
                  <div className='header-actions'>
                    {firebase.auth()?.currentUser?.photoURL ? (<>
                      <div className='w-8 h-8 rounded-full relative'>
                        <img src={firebase.auth().currentUser.photoURL} className='w-8 h-8 rounded-full' alt="Profile" />
                        <div className='w-2 h-2 rounded-full bg-green-400 absolute top-0 right-0'></div>
                      </div>
                    </>) : (
                      <div className='flex items-center justify-center p-2 rounded-full bg-gray-200 ml-1 relative'>
                        <FaUser size={15} color='#FF6600' />
                        <div className='w-2 h-2 rounded-full bg-green-400 absolute top-0 right-0'></div>
                      </div>
                    )
                    }
                  </div>

                </div>
              </header>
              <div className='w-full flex' style={{ height: '92vh' }}>
                <div className='sidebar flex flex-col bg-white p-[20px]' style={{ width: '250px', height: '92vh' }}>
                  <div className='menu-item' onClick={() => navigate('/admin')} >
                    <FiHome size={18} className='menu-icon' />
                    <p className='menu-text'>Dashboard</p>
                  </div>
                  <div className='menu-item' onClick={() => navigate('/admin/applications')}>
                    <FiFileText size={18} className='menu-icon' />
                    <p className='menu-text'>Applications</p>
                  </div>
                  <div className='pro-container mt-auto'>
                    <button className='pro-btn' onClick={logout}>Logout</button>
                  </div>
                </div>
                <Content className="flex bg-gray-100" style={{ minHeight: '92vh', overflow: 'auto', width: 'calc(100% - 250px)' }}>
                  <Outlet />
                </Content>
              </div>

            </div>
          )}
        </>
      )}
    </>
  );
}

export default AdminLayout;
